var _a;
import React from "react";
import { useSelector } from "react-redux";
// icons
import PaperIcon from "../../asstes/paper.svg";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/draft.scss";
import { TransactionTypeCodeEnum } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
var messages = (_a = {},
    _a[TransactionTypeCodeEnum.Purchase] = {
        title: "Great! Your client's purchase request has been recorded successfully.",
        subtitle: "Once the manufacturer confirms, you can track it in the order book. This usually takes 3-4 days.",
    },
    _a[TransactionTypeCodeEnum.TopUp] = {
        title: "Great! Your client's top-up request has been recorded successfully.",
        subtitle: "Once the manufacturer confirms, you can track it in the order book. This usually takes 3-4 days.",
    },
    _a[TransactionTypeCodeEnum.Redeem] = {
        title: "Great! Your client's redemption request has been sent to CXO for QC approval.",
        subtitle: "Track your order status in the Orderbook for the latest updates.",
    },
    _a[TransactionTypeCodeEnum.TransferIn] = {
        title: "Great! Your client's ARN Transfer request is registered.",
        subtitle: "Track your order status in the Orderbook for the latest updates.",
    },
    _a);
var SuccessPage = function () {
    var activeTypeList = useSelector(function (state) { return state.markets.global; }).activeTypeList;
    var message = messages[activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "draft-already-container bg-white d-flex flex-column align-items-center h-100" },
            React.createElement("img", { src: PaperIcon, alt: "PaperIcon" }),
            message && (React.createElement("div", { className: "draft-already-inner px-5" },
                React.createElement("h6", { className: "DMSansMedium_20_500 text-center" }, message.title),
                React.createElement("p", { className: "DMSans_13_400" }, message.subtitle))))));
};
export default SuccessPage;
